import './background.css';

type AnimatedGradientBackgroundProps = {
  className?: string;
};

export function AnimatedGradientBackground({ className = '' }: AnimatedGradientBackgroundProps) {
  return (
    <div className={`animated-gradient-background ${className}`} aria-hidden="true">
      <svg
        className="animated-gradient-background__svg"
        width="100%"
        height="100%"
        viewBox="0 0 800 600"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="xMidYMid slice"
      >
        <defs>
          <linearGradient id="invitecloud-bg-grad-1" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="var(--color-primary, #574eb1)" stopOpacity="0.8" />
            <stop offset="100%" stopColor="var(--color-status-processing, #ef9f27)" stopOpacity="0.6" />
          </linearGradient>
          <linearGradient id="invitecloud-bg-grad-2" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="var(--color-brand-deep, #3c3489)" stopOpacity="0.75" />
            <stop offset="50%" stopColor="var(--color-surface-low, #f6f2fb)" stopOpacity="0.7" />
            <stop offset="100%" stopColor="var(--color-status-published, #1d9e75)" stopOpacity="0.48" />
          </linearGradient>
          <radialGradient id="invitecloud-bg-grad-3" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="var(--color-status-failed, #e24b4a)" stopOpacity="0.55" />
            <stop offset="100%" stopColor="var(--color-primary-dark, #534ab7)" stopOpacity="0.34" />
          </radialGradient>
          <filter id="invitecloud-bg-blur-1" x="-50%" y="-50%" width="200%" height="200%">
            <feGaussianBlur stdDeviation="35" />
          </filter>
          <filter id="invitecloud-bg-blur-2" x="-50%" y="-50%" width="200%" height="200%">
            <feGaussianBlur stdDeviation="25" />
          </filter>
          <filter id="invitecloud-bg-blur-3" x="-50%" y="-50%" width="200%" height="200%">
            <feGaussianBlur stdDeviation="45" />
          </filter>
        </defs>

        <g className="animated-gradient-background__float-one">
          <ellipse
            cx="200"
            cy="500"
            rx="250"
            ry="180"
            fill="url(#invitecloud-bg-grad-1)"
            filter="url(#invitecloud-bg-blur-1)"
            transform="rotate(-30 200 500)"
          />
          <rect
            x="500"
            y="100"
            width="300"
            height="250"
            rx="80"
            fill="url(#invitecloud-bg-grad-2)"
            filter="url(#invitecloud-bg-blur-2)"
            transform="rotate(15 650 225)"
          />
        </g>

        <g className="animated-gradient-background__float-two">
          <circle
            cx="650"
            cy="450"
            r="150"
            fill="url(#invitecloud-bg-grad-3)"
            filter="url(#invitecloud-bg-blur-3)"
            opacity="0.7"
          />
          <ellipse
            cx="50"
            cy="150"
            rx="180"
            ry="120"
            fill="var(--color-surface-low, #f6f2fb)"
            filter="url(#invitecloud-bg-blur-2)"
            opacity="0.86"
          />
        </g>
      </svg>
      <div className="animated-gradient-background__glass" />
    </div>
  );
}
